import React from 'react'

// This is where we will get the popular posts

const PopularCommunities = () => {
  return (
    <div className='popularCommunities'></div>
  )
}

export default PopularCommunities